const SET_CORE_CONCEPT_VIDEO_COURSES = 'videoCourses/SET_CORE_CONCEPT_VIDEO_COURSES';
const SET_UNITS_WITH_CORE_CONCEPTS = 'videoCourses/SET_UNITS_WITH_CORE_CONCEPTS';
const REMOVE_VIDEO_COURSE = 'videoCourses/REMOVE_VIDEO_COURSE';
const SET_VIDEO_COURSES = 'videoCourses/SET_VIDEO_COURSES';
const SET_CORE_CONCEPT_VIDEO_COURSE = 'videoCourses/SET_CORE_CONCEPT_VIDEO_COURSE';
const FETCH_CORE_CONCEPT_VIDEO_COURSES = 'videoCourses/FETCH_CORE_CONCEPT_VIDEO_COURSES';
const UPDATE_CORE_CONCEPT_VIDEO_COURSE = 'videoCourses/UPDATE_CORE_CONCEPT_VIDEO_COURSE';

export default {
  SET_CORE_CONCEPT_VIDEO_COURSES,
  SET_UNITS_WITH_CORE_CONCEPTS,
  REMOVE_VIDEO_COURSE,
  SET_VIDEO_COURSES,
  SET_CORE_CONCEPT_VIDEO_COURSE,
  FETCH_CORE_CONCEPT_VIDEO_COURSES,
  UPDATE_CORE_CONCEPT_VIDEO_COURSE,
};



// WEBPACK FOOTER //
// ./src/app/video-courses/store/mutation-types.js